module.exports = __webpack_public_path__ + "img/lines.a7e14ec1.png";